
import EditBase from "../EditBase"

class EditPolylineVolume extends EditBase {

    constructor(options) {
        super(options);
    }

    
    initProperty() {
        var $this = this;
        var attr = $this.plot.polylineVolume.attr;

        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            return $this.calcGlobeHeight($this.plot.attrPlot["edit_positions"]);
        }, !$this.editing);

        var shapeProperty=new $this.Cesium.CallbackProperty(function () {
            var r=$this.plot.attrPlot["oldHeight"] ||  10;
            return $this.drawBase.computeCircle(r);
        }, !$this.editing);

        this.plot.polylineVolume.positions = positionsProperty;
        $this.plot.polylineVolume.shape=shapeProperty;

        if (attr && attr.oldHeight) {
            $this.plot.attrPlot= $this.plot.attrPlot || {};
            $this.plot.attrPlot["oldHeight"]=attr.oldHeight;
        }
    }


    heightMoveAll(endPosition, startPosition) {
        var $this = this;
        var zOffset = new Cesium.Cartesian3();
        //改变高度垂直拖动
        var dy = endPosition.y - startPosition.y;

        var position = $this.heightPos.position.getValue();
        //获取该点的投影面
        var tangentPlane = new Cesium.EllipsoidTangentPlane(position);
        var scratchBoundingSphere = new Cesium.BoundingSphere(); //包围球体
        scratchBoundingSphere.center = position;
        scratchBoundingSphere.radius = 1;

        //获取像素大小-米
        var metersPerPixel = $this.viewer.scene.frameState.camera.getPixelSize(scratchBoundingSphere, $this.viewer.scene.frameState.context.drawingBufferWidth, $this.viewer.scene.frameState.context.drawingBufferHeight);
        var heightDiff = -dy * metersPerPixel;
        Cesium.Cartesian3.multiplyByScalar(tangentPlane.zAxis, heightDiff, zOffset);
        var newPosition = Cesium.Cartesian3.clone(position);
        Cesium.Cartesian3.add(position, zOffset, newPosition);

        //更新开始
        var oldHeight = $this.plot.attrPlot["oldHeight"] ||  10;
        var newHight=oldHeight + heightDiff;
        $this.plot.attrPlot["oldHeight"]=newHight;
        $this.heightPos.position.setValue(newPosition);
        $this.plot.attrPlot["edit_extrudedHeight"] = {
            getValue: () => {
                return newHight
            }
        };
    }

}

export default EditPolylineVolume